define( 'views/fields/preview/repeaterElementLayout',[ 'views/fields/preview/repeaterElementCollection' ], function( previewRepeaterElementCollectionView ) {
	var view = Marionette.LayoutView.extend({
		tagName: 'div',
		template: '#tmpl-nf-field-repeater',

		regions: {
			fields: '.nf-repeater-fieldsets',
		},

		initialize: function( data ) {
			this.collection = data.collection;
			this.model = data.model;
		},

		onRender: function() {
			// Populate the fields region with our collection view.
			this.fields.show( new previewRepeaterElementCollectionView( { collection: this.collection, repeaterFieldModel: this.model } ) );
		},

		templateHelpers: function() {
			return {
				maybeFilterHTML: function()  {
					return typeof nfAdmin.filter_esc_status !== "undefined" ? nfAdmin.filter_esc_status : "false";
				},
				renderDescText: function() {
					// ...
				},
			}
		},
	});

	return view;
} );
